"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Executor = exports.MOTC = void 0;
const types_1 = require("./types");
const chunk_1 = require("./chunk");
var Flag;
(function (Flag) {
    Flag[Flag["LEFT_BRACE"] = 123] = "LEFT_BRACE";
    Flag[Flag["RIGHT_BRACE"] = 125] = "RIGHT_BRACE";
    Flag[Flag["COLON"] = 58] = "COLON";
    Flag[Flag["COMMA"] = 44] = "COMMA";
    Flag[Flag["SEMICOLON"] = 59] = "SEMICOLON";
    Flag[Flag["HASH"] = 35] = "HASH";
    Flag[Flag["AT"] = 64] = "AT";
    Flag[Flag["SPACE"] = 32] = "SPACE";
    Flag[Flag["NEWLINE"] = 10] = "NEWLINE";
})(Flag || (Flag = {}));
class MOTC {
    constructor(_src) {
        this._src = _src;
        this._mot = {
            metadata: {},
            chunks: []
        };
        this._ptr = 0;
        this._atMetaName = false;
        this._atMetaData = false;
        this._atChunkName = false;
        this._atChunk = false;
        this._atScopeName = false;
        this._atScope = false;
        this._atPropertyName = false;
        this._atPropertyValue = false;
        this._atStatement = false;
        this._tempString = ""; // currently pointed string
        this._tempKeyword = ""; // currently pointed keyword
        this._tempChunk = null; // currently pointed chunk
        this._tempScope = null; // currently pointed scope
    }
    _tokenize() {
        for (this._ptr; this._ptr < this._src.length; this._ptr++) {
            const char = this._src[this._ptr];
            const code = this._getCharCode(this._ptr);
            switch (code) {
                case Flag.LEFT_BRACE:
                    if (this._atChunk && !this._atScopeName && !this._atScope) {
                        this._atScopeName = true;
                    }
                    else if (this._atChunk && this._atScope) {
                        switch (this._tempChunk.name) {
                            case types_1.ChunkType.OBJECTS:
                                this._atPropertyName = true;
                                break;
                            case types_1.ChunkType.WHEN:
                                this._atStatement = true;
                                break;
                        }
                    }
                    break;
                case Flag.RIGHT_BRACE:
                    if (this._atScope) {
                        this._atScope = false;
                        this._atPropertyValue = false;
                        this._atStatement = false;
                        this._atScopeName = true;
                        this._tempScope = null;
                    }
                    else {
                        this._resetStatus();
                    }
                    break;
                case Flag.HASH:
                    this._atMetaName = true;
                    break;
                case Flag.AT:
                    this._atChunkName = true;
                    break;
                case Flag.COLON:
                    if (this._atPropertyName) {
                        this._atPropertyName = false;
                        this._atPropertyValue = true;
                    }
                    break;
                case Flag.SPACE:
                    if (this._atMetaData) {
                        this._tempString += char;
                        continue;
                    }
                    if (this._atMetaName) {
                        this._atMetaName = false;
                        this._addMeta(this._tempKeyword, "");
                        this._atMetaData = true;
                    }
                    else if (this._atChunkName) {
                        this._atChunkName = false;
                        this._tempChunk = this._addChunk(this._tempKeyword);
                        this._tempKeyword = "";
                        this._atChunk = true;
                    }
                    else if (this._atScopeName && this._tempKeyword.length > 0) {
                        this._atScopeName = false;
                        this._tempScope = this._tempChunk.addScope(this._tempKeyword);
                        this._tempKeyword = "";
                        this._atScope = true;
                    }
                    else if (this._atStatement && this._tempString.length > 0) {
                        this._tempString += char;
                    }
                    break;
                case Flag.NEWLINE:
                    if (this._atMetaData) {
                        this._addMeta(this._tempKeyword, this._tempString);
                        this._resetTemp();
                        this._resetStatus();
                    }
                    else if (this._atPropertyValue) {
                        this._atPropertyValue = false;
                        this._tempScope.addProperty(this._tempKeyword, this._tempString);
                        this._tempKeyword = this._tempString = "";
                        this._atPropertyName = true;
                    }
                    else if (this._atStatement && this._tempString.length > 0) {
                        const processed = this._tempString.split(" ");
                        this._tempScope.addStatement(processed[0], processed.slice(1));
                        this._tempString = "";
                    }
                    break;
                default: // Other characters
                    if (this._atMetaName ||
                        this._atChunkName ||
                        this._atScopeName ||
                        this._atPropertyName) {
                        this._tempKeyword += char;
                    }
                    else if (this._atMetaData || this._atPropertyValue || this._atStatement) {
                        this._tempString += char;
                    }
                    break;
            }
        }
        return this._mot;
    }
    _resetStatus() {
        this._atMetaName = false;
        this._atMetaData = false;
        this._atChunkName = false;
        this._atChunk = false;
        this._atScopeName = false;
        this._atScope = false;
        this._atPropertyName = false;
        this._atPropertyValue = false;
        this._atStatement = false;
    }
    _resetTemp() {
        this._tempString = "";
        this._tempKeyword = "";
        this._tempChunk = null;
        this._tempScope = null;
    }
    _addMeta(key, value) {
        this._mot.metadata[key] = value;
    }
    _addChunk(name) {
        let chunk;
        switch (name) {
            case types_1.ChunkType.OBJECTS:
                chunk = new chunk_1.ObjectsChunk();
                break;
            case types_1.ChunkType.WHEN:
                chunk = new chunk_1.WhenChunk();
                break;
        }
        this._mot.chunks.push(chunk);
        return chunk;
    }
    _getCharCode(index) {
        return this._src[index].charCodeAt(0);
    }
    static parse(src) {
        return new MOTC(src)._tokenize();
    }
    /** @todo */
    static stringify(mot) {
        return "";
    }
}
exports.MOTC = MOTC;
class Executor {
    constructor(_renderer) {
        this._renderer = _renderer;
    }
    execute(mot) {
        for (const chunk of mot.chunks) {
            if (chunk instanceof chunk_1.ObjectsChunk) {
                for (const scope of chunk.members) {
                    const properties = scope.properties;
                    try {
                        /** @todo */
                        console.log(properties);
                    }
                    catch (e) {
                        alert("Failed when importing mot file.");
                    }
                }
            }
            if (chunk instanceof chunk_1.WhenChunk) {
                // for(const scope of chunk.members) {
                //     
                // }
            }
        }
    }
}
exports.Executor = Executor;
